import { VmsCreditMemoLineModel } from './vms-credit-memo-line-model';
export class VmsCreditMemo {
    PostedInvoiceNo:any="";    
    PreInvoiceNo:any="";
    PostRefInvNo:any="";
    PreRefInvoiceNo:any="";
    SalesCreditNo:any="";
    Department:any="";
    InvoiceDate:any="";
    Structure:any="";
    VendorCreditMemoNo:any="";
    Location:any="";
    TotBaseAmount:any="";
    NetTotal:any="";
    ContactEmail:any="";
    Pointofcontact:any='';
    Remark:any="";
    ReasonForRejection:any="";
    AppliedDocumentNo:any="";
    PreAppliedDocumentNo:any="";
    OrderAddressCode:any="";
    VendorNo:any='';
    Status:string='';
    SubmittedFlag:any;
    DraftFlag:any
    GSTTotal:any;
    cMLineModels:VmsCreditMemoLineModel[];
}

